"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function BSquare(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M20.05 2C21.13 2 22 2.87 22 3.95v16.1c0 1.08-.87 1.95-1.95 1.95H3.95C2.87 22 2 21.13 2 20.05V3.95C2 2.87 2.87 2 3.95 2zM20 3.95L3.95 4 4 20.05 20 20V3.95zM12 5c3.859 0 7 3.141 7 7s-3.141 7-7 7-7-3.141-7-7 3.141-7 7-7zm0 2c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm.299 2c.822 0 1.449.153 1.879.453.429.303.644.74.644 1.315 0 .33-.078.613-.228.848a1.33 1.33 0 0 1-.674.517c.334.088.59.254.769.492.178.242.268.535.268.879 0 .629-.197 1.1-.596 1.414-.396.315-.984.475-1.763.48H10V9h2.299zm.326 3.678h-1.082v1.535h1.012c.277 0 .492-.064.64-.191.151-.127.225-.307.225-.54 0-.533-.266-.8-.795-.804zm-.326-2.49h-.756v1.48h.805c.336-.002.576-.064.72-.185.143-.12.215-.297.215-.534 0-.27-.078-.464-.232-.584-.156-.12-.406-.177-.752-.177z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = BSquare;
